import useTrans from "@/hooks/useTrans";
import { Box, Grid, Text } from "@mantine/core";
import React from "react";
import useStyles from "../styles/CartLeftSection";
import CartItem from "./CartItem";

function CartLeftSection() {
  const { classes } = useStyles();
  const trans = useTrans();
  return (
    <Grid.Col lg={8}>
      <Box className={classes.container}>
        <Box className={classes.chooseNowSection}>
          <Text className={classes.chooseNowTitle}>{trans.cart.choose}</Text>
        </Box>
        <CartItem />
      </Box>
    </Grid.Col>
  );
}

export default CartLeftSection;
